import { useTHGGlobalStore } from '@/storenew/thg/global';

export const api_url = () => {
    // read currentCountry from store in this callable/function
    const { currentCountry } = useTHGGlobalStore();

    return `${process.env.VUE_APP_THG_API_HOST}/${currentCountry}/api/v1`;
};
